module.exports = __webpack_public_path__ + "static/media/cusdt.23924a7b.svg";